import React from 'react';
import { HelmetProvider } from 'react-helmet-async';
import { QueryClientProvider } from '@tanstack/react-query';
import { BrowserRouter as Router } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { AuthProvider } from './AuthProvider';
import { getOrCreateQueryClient } from '../../shared/query/createQueryClient';
import { installAttention } from '../../shared/query/attention';

import '@reactflow/node-resizer/dist/style.css';

const queryClient = getOrCreateQueryClient();
installAttention(queryClient);

export function AppProviders({ children }) {
  return (
    <QueryClientProvider client={queryClient}>
      <ToastContainer position="top-right" autoClose={3000} />
      <HelmetProvider>
        <Router>
          <AuthProvider>{children}</AuthProvider>
        </Router>
      </HelmetProvider>
    </QueryClientProvider>
  );
}
